import axios from 'axios';
import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_APPOINTMENT_DETAIL = 'GET_APPOINTMENT_DETAIL';
export const GET_APPOINTMENT_DETAIL_SUCCESS = 'GET_APPOINTMENT_DETAIL_SUCCESS';
export const GET_APPOINTMENT_DETAIL_FAILURE = 'GET_APPOINTMENT_DETAIL_FAILURE';

// Action Creators
export const getAppointmentDetailRequest = () => ({
  type: GET_APPOINTMENT_DETAIL,
});

export const getAppointmentDetailSuccess = (users) => ({
  type: GET_APPOINTMENT_DETAIL_SUCCESS,
  payload: users,
});

export const getAppointmentDetailFailure = (error) => ({
  type: GET_APPOINTMENT_DETAIL_FAILURE,
  payload: error,
});

// Thunk Function
export const getAppointmentDetail = (external, id) => {
  return async (dispatch) => {
    dispatch(getAppointmentDetailRequest());
    try {
      const response = await getMethodWithToken(
        url?.appointmentDetail + id + '/'
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getAppointmentDetailSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getAppointmentDetailFailure(error?.message));
    }
  };
};
